import React from "react";
//import Main from "../components/Main";
import Works from "../components/Works";
const Home = () => {
  return (
    <main>
      <Works />
    </main>
  );
};

export default Home;
